<template>
  <custom-callout
    :border-color="statusColor.color"
    class-main="mt-3 rounded"
    :has-toggle="false"
    :opened="true"
  >
    <div class="row py-2 mr-md-0 align-items-center">
      <div class="col-12 col-md-2 text-center border-right mr-5">
        <div class="d-flex flex-column font-weight-bold color-black">
          <span
            :class="`mb-1 badge badge-pill font-14 pt-2 pb-2 `"
            :style="`${statusColor.badged}`"
          >
            {{ data.statusName | empty }}
          </span>
        </div>
      </div>
      <div class="col col-sm col-12 mt-3 mt-md-0">
        <div class="color-gray-6 font-14">Tipo de Documento:</div>
        <div class="color-black font-16">
          {{ data.documentTypeName | empty }}
        </div>
      </div>
      <div class="col col-sm col-12 mt-3 mt-md-0">
        <div class="color-gray-6 font-14">Archivo:</div>
        <div class="color-black font-16">
          {{ data.filename | empty }}
        </div>
      </div>
      <div class="col col-sm col-12 mt-3 mt-md-0">
        <div class="color-gray-6 font-14">Fecha de Sometido:</div>
        <div class="color-black font-16">
          {{ data.contractDocumentDate | date }}
        </div>
      </div>
      <div
        class="col col-sm col-12 d-flex align-items-center justify-content-end"
      >
        <action-button
          id="download-btn"
          i="fas fa-file-download pl-1 mt-1"
          variant="success"
          @click="donwload"
        />
      </div>
    </div>
  </custom-callout>
</template>

<script>
import CustomCallout from 'custom-callout';
import ActionButton from 'ActionButton';

export default {
  name: 'InterventionPlanResultRow',
  components: {
    CustomCallout,
    ActionButton,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    donwload() {
      this.$emit('donwload-document', this.data.documentId);
    },
  },
  computed: {
    statusColor() {
      return {
        color: 'yellow',
        badged: 'background-color: #f8ea80',
      };
    },
  },
};
</script>

<style scoped lang="scss">
#download-btn {
  padding-left: 5px;
  padding-right: 3px;
  padding-top: 3px;
  padding-bottom: 3px;
}
</style>
